/** Cache tag for inventory (registered in apiSlice's tagTypes). */
export enum InventoryTags {
  Inventory = "Inventory",
}
